export const type_hash = {
   0:'正式员工',
   9:'动车会',
   10:'实习生',
   20:'外包员工',
   30:'挂靠员工',
   40:'劳务派遣',
   50: '大规模用工',
   60:'云账户',
   70: '其他类型',
   100:'公共账号',
   110:'游客和外部访客',
}
export const type_list = Object.keys(type_hash).map(key => {
    return {
        value:Number(key),
        label: type_hash[key]
    }
})
const util = {
    customerTypeName(type) {
        return type_hash[type] || '未定义员工类型'
    },
    type_list
};

export default util;
